import styled from 'styled-components';
import { spacing, fontSizes, Subtitle2 } from 'ui/theme';
import { SecondaryButton } from 'ui/button';
import ListSelect from '../../formElements/ListSelect/ListSelect';
import ListSelectV2 from '../../formElements/ListSelect/ListSelectV2';

export const DefineAudienceSelectWrapper = styled.div`
  display: flex;
  justify-content: row;
  gap: ${spacing.half};

  div + button {
    flex-shrink: 0;
  }
`;

export const StyledSubtitle2 = styled(Subtitle2)`
  margin-bottom: ${spacing.base};
`;

export const MiniSubtitle2 = styled(Subtitle2)`
  font-size: ${fontSizes.s12};
  margin-bottom: ${spacing.quarter};
`;

export const StyledListSelect = styled(ListSelect)`
  width: 100%;
`;
export const StyledListSelectV2 = styled(ListSelectV2)`
  width: 100%;
`;

export const SuppressListWrapper = styled.div`
  > div {
    width: 100%;
  }
`;

export const CriteriaButton = styled(SecondaryButton)`
  z-index: 0 !important;
`;

export const CriteriaWrapper = styled.div`
  display: flex;
  gap: ${spacing.half};
  align-items: center;
`;
